import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage, getImage } from "gatsby-plugin-image"


const FeedbackAvatar = ({ image }) => {
  const imageData = getImage(image)
  if (!image) {
    return <div style={{ width: "120px" }}>No avatar</div>
  }
  return <GatsbyImage style={{ borderRadius: "40px" }} image={imageData} alt="" />
}

FeedbackAvatar.propTypes = {
  image: PropTypes.shape({
    relativePath: PropTypes.string,
    childImageSharp: PropTypes.object
  })
}

export default FeedbackAvatar
